<template>
    <div class="test">
        <div v-if="flag">
            <el-form-item :label-width="formLabelWidth" style="margin-bottom: 0;line-height:30px" :required="true"
                          v-loading="loading">
                <div class="row">
                    <span class="col-sm-4  text-lr"><i class="fa fa-asterisk text-danger font10 ml-1"
                                                       aria-hidden="true"></i>所属区域:</span>
                    <el-dropdown ref="dropdown" style="margin-top: -10px" class="col-sm-7" size="small">
                        <el-input v-model="regionName" placeholder="请选择">
                        </el-input>
                        <el-dropdown-menu slot="dropdown"
                                          style="width: 300px;max-height: 300px;overflow-y: scroll">
                            <el-tree :data="regionData" :props="defaultProps"
                                     @node-click="handleNodeClick"></el-tree>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </el-form-item>
            <el-form-item style="margin-bottom: 0" :label-width="formLabelWidth" label="">
                <div class="row">
                    <span class="col-sm-4  text-lr">气候区:</span>
                    <div class="col-sm-7"> {{
                            areaInfo.weather === null || areaInfo.weather === undefined ? '--' : areaInfo.weather
                        }}
                    </div>
                </div>
            </el-form-item>
            <el-form-item style="margin-bottom: 0" :label-width="formLabelWidth" label="">
                <div class="row">
                    <span class="col-sm-4  text-lr">地理分区:</span>
                    <div class="col-sm-7">
                        {{ areaInfo.area === null || areaInfo.area === undefined ? '--' : areaInfo.area }}
                    </div>
                </div>

            </el-form-item>
            <el-form-item style="margin-bottom: 0" :label-width="formLabelWidth" label="">
                <div class="row">
                    <span class="col-sm-4  text-lr">城市发展水平:</span>
                    <div class="col-sm-7"> {{
                            areaInfo.city_level === null || areaInfo.city_level === undefined ? '--' : areaInfo.city_level
                        }}
                    </div>
                </div>
            </el-form-item>
            <el-form-item style="margin-bottom: 0" :label-width="formLabelWidth" label="">
                <div class="row">
                    <span class="col-sm-4  text-lr">经度:</span>
                    <div class="col-sm-7">{{
                            areaInfo.longitude === null || areaInfo.longitude === undefined ? '--' : areaInfo.longitude
                        }}
                        °
                    </div>
                </div>

            </el-form-item>
            <el-form-item style="margin-bottom: 0" :label-width="formLabelWidth" label="">
                <div class="row">
                    <span class="col-sm-4  text-lr">纬度:</span>
                    <div class="col-sm-7"> {{
                            areaInfo.latitude === null || areaInfo.latitude === undefined ? '--' : areaInfo.latitude
                        }}
                        °
                    </div>
                </div>

            </el-form-item>
            <el-form-item style="margin-bottom: 0" :label-width="formLabelWidth" label="">
                <div class="row">
                    <span class="col-sm-4  text-lr">海拔:</span>
                    <div class="col-sm-7"> {{
                            areaInfo.altitude === null || areaInfo.altitude === undefined ? '--' : areaInfo.altitude
                        }}
                        m
                    </div>
                </div>

            </el-form-item>
            <el-form-item style="margin-bottom: 10px" :label-width="formLabelWidth" label="">
                <div class="row">
                    <span class="col-sm-4  text-lr">抗震设防烈度:</span>
                    <div class="col-sm-7">{{
                            areaInfo.seismic === null || areaInfo.seismic === undefined ? '--' : areaInfo.seismic
                        }}
                    </div>
                </div>

            </el-form-item>
        </div>
    </div>
</template>

<script>

export default {
    name: "EnumrTemp",
    props: [
        'Data',
    ],
    data() {
        return {
            loading: false,
            regionName: '',
            regionData: [],
            defaultProps: {
                children: 'sonList',
                label: 'name',
                id: 'code',
            },
            value: '',
            formLabelWidth: '',
            areaInfo: [],
            data: [],
            name1: '',
            name2: '',
            name3: '',
            flag:true
        }
    },
    created() {
        this.getRegionChange()
        this.dealData()
    },
    methods: {
        clearData(){
            this.flag=false
            console.log('sd2222')
            this.areaInfo=[]
            this.regionData=[]
            this.regionName=''
            this.name1=''
            this.$nextTick(()=>{
                            this.flag=true

            })
        },
        dealData() {
            var list = this.$store.state.project_data.object_data.static_attribute

            for (let i in list) {
                if (list[i].c_code === '311003') {
                    this.name1 = list[i].c_value
                }
                if (list[i].c_code === '311002') {
                    this.name2 = list[i].c_value
                }
                if (list[i].c_code === '311001') {
                    this.name3 = list[i].c_value
                }
                if (list[i].c_code === '311010') {
                    this.areaInfo.seismic = list[i].c_value
                }
                if (list[i].c_code === '311009') {
                    this.areaInfo.altitude = list[i].c_value
                }
                if (list[i].c_code === '311008') {
                    this.areaInfo.latitude = list[i].c_value
                }
                if (list[i].c_code === '311007') {
                    this.areaInfo.longitude = list[i].c_value
                }
                if (list[i].c_code === '311006') {
                    this.areaInfo.city_level = list[i].c_value
                }
                if (list[i].c_code === '311005') {
                    this.areaInfo.weather = list[i].c_value
                }
            }
            if(this.name3===null){
                this.regionName=''
                return
            }
            this.regionName = this.name3 + '-' + this.name2 + '-' + this.name1

        },
        // 获取省市区数据
        getRegionChange() {
            this.loading = true
            this.$axios({
                method: 'post',
                url: this.IBMS_API + 'Common/region',
                data: {}
            }).then((response) => {
                this.regionData = response.data.content
                this.loading = false
            })
        },
        // 树节点的点击事件
        handleNodeClick(a, Node) {
            console.log(a, Node, 'as')
            if (a.sonList.length === 0) {
                this.$get_function({'obj': 'project', 'data': {'c_code': '311003'}}, Node.data.name)
                this.$get_function({'obj': 'project', 'data': {'c_code': '311002'}}, Node.parent.data.name)
                this.$get_function({'obj': 'project', 'data': {'c_code': '311001'}}, Node.parent.parent.data.name)
                this.regionName = Node.parent.parent.data.name + '-' + Node.parent.data.name + '-' + Node.data.name
                this.areaInfo = []
                for (let i in this.regionData) {
                    for (let x in this.regionData[i].sonList) {
                        for (let y in this.regionData[i].sonList[x].sonList) {
                            if (a.code === this.regionData[i].sonList[x].sonList[y].code) {
                                this.areaInfo = this.regionData[i].sonList[x].sonList[y]
                                this.$get_function({
                                    'obj': 'project',
                                    'data': {'c_code': '311010'}
                                }, this.areaInfo.seismic)
                                this.$get_function({
                                    'obj': 'project',
                                    'data': {'c_code': '311009'}
                                }, this.areaInfo.altitude)
                                this.$get_function({
                                    'obj': 'project',
                                    'data': {'c_code': '311008'}
                                }, this.areaInfo.latitude)
                                this.$get_function({
                                    'obj': 'project',
                                    'data': {'c_code': '311007'}
                                }, this.areaInfo.longitude)
                                this.$get_function({
                                    'obj': 'project',
                                    'data': {'c_code': '311006'}
                                }, this.areaInfo.city_level)
                                this.$get_function({
                                    'obj': 'project',
                                    'data': {'c_code': '311005'}
                                }, this.areaInfo.weather)
                                this.$get_function({'obj': 'project', 'data': {'c_code': '311011'}}, this.areaInfo.area)
                            }
                        }
                    }
                }
                this.$refs.dropdown.hide()
            }
        },
    }
}
</script>

<style scoped>

.test .el-input {
    width: 220px;
    margin: 10px 0;
}
</style>
